import { UNISON_PROJECT_TYPE_ID } from '@witmetrics/utils/constants';
import { addToArray } from '@witmetrics/utils/arrays';
import { useNewCase } from '@/providers/NewCaseProvider';
import StepsBlock, {
  Step,
  type StepsBlockProps,
} from '@/components/StepsBlock';
import PatientStep from '../PatientStep';
import FilesStep from '../FilesStep';
import CaseSettingsStep from '../CaseSettingsStep';
import ReviewStep from '../ReviewStep';
import type { WizardStep } from '../../types';
import { WIZARD_STEPS } from '../../constants';
import { classes, isMissingScans } from './utils';

const { OTHER, VENEERS } = UNISON_PROJECT_TYPE_ID;
const { SELECT_PATIENT, SELECT_FILES, CASE_SETTINGS, REVIEW } = WIZARD_STEPS;

export type CaseStepsBlockProps = {
  activeStep: WizardStep;
  onNavigate: (step: WizardStep) => void;
};

export default function CaseStepsBlock({
  activeStep,
  onNavigate,
}: CaseStepsBlockProps) {
  const { leadId, projectTypeId, serviceType, selectedFiles } = useNewCase();
  let steps: StepsBlockProps<WizardStep[]>['children'] = [
    <Step
      key={SELECT_PATIENT}
      className={classes.step}
      name={SELECT_PATIENT}
      label="Patient">
      <PatientStep onSave={() => onNavigate(WIZARD_STEPS.SELECT_FILES)} />
    </Step>,
    <Step
      key={SELECT_FILES}
      disabled={!leadId}
      className={classes.step}
      name={SELECT_FILES}
      label="Files">
      <FilesStep />
    </Step>,
    <Step
      key={REVIEW}
      disabled={!leadId || isMissingScans(serviceType, selectedFiles)}
      className={classes.step}
      name={REVIEW}
      label="Review & Create">
      <ReviewStep
        onEditPatient={() => onNavigate(WIZARD_STEPS.SELECT_PATIENT)}
      />
    </Step>,
  ];

  if (projectTypeId !== OTHER && projectTypeId !== VENEERS) {
    steps = addToArray(
      steps,
      <Step
        key={CASE_SETTINGS}
        disabled={!leadId || isMissingScans(serviceType, selectedFiles)}
        className={classes.step}
        name={CASE_SETTINGS}
        label="Custom Settings">
        <CaseSettingsStep />
      </Step>,
      true,
      2
    );
  }

  return (
    <StepsBlock<WizardStep[]>
      className={classes.stepper}
      name="new-case-wizard"
      bodyClassName={classes.stepperBody}
      defaultStep={activeStep}
      onChange={onNavigate}>
      {steps}
    </StepsBlock>
  );
}
